import type { Loan } from 'app/types/loan';
import { startOfDay } from 'date-fns';

export function getTimelineMilestones(start: string, end: string, now: Date) {
  const today = startOfDay(now).getTime();
  const startDay = startOfDay(new Date(start)).getTime();
  const endDay = startOfDay(new Date(end)).getTime();
  if (today > endDay) return ['start', 'end', 'today'] as const;
  return today < startDay ? (['today', 'start', 'end'] as const) : (['start', 'today', 'end'] as const);
}

export function getTimelineEnd(loan: Pick<Loan, 'status' | 'end' | 'returned'>, isService: boolean, now: Date) {
  const isReturned = loan.status === 'returned' || loan.status === 'completed';
  const isLate = loan.status === 'accepted' && startOfDay(now) > startOfDay(new Date(loan.end));
  return {
    date: isReturned ? (loan.returned ?? loan.end) : loan.end,
    label: isService ? 'endService' : isReturned ? 'returned' : isLate ? 'dueDate' : 'end',
    isReturned,
  };
}
